import { authnClient } from '@frontend/auth';
import { http } from '@frontend/fetch';
import { resetAllStores } from '@frontend/store';
import { sentry } from '@frontend/tracking';

let signOutInProgress = false;

export const isSignOutInProgress = () => signOutInProgress;

// signOut will end in a browser redirect away from the current page, the promise will never be resolved
// if you need side effects performed make sure to do them before calling this method
export const signOut = async () => {
  try {
    signOutInProgress = true;
    http.clearAllInterceptors();
    resetAllStores();

    // clear the user from Sentry so that any errors that occur after sign out will not be associated with the previously signed in user
    sentry.instance.setUser(null);

    // will navigate away from the current page, so the promise will never resolve
    await authnClient.signOut();
  } finally {
    // if something in the above code throws, we want to make sure that we reset the signOutInProgress flag so that the user can try to sign out again
    signOutInProgress = false;
  }
};
